<!-- <div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">

        

                <div>
                    <div class="d-flex">
                        <ng-container *ngFor="let element of options;let i=index">
                            <input-check class="mr-2" [(ngModel)]="element.checked" name="add{{i}}" [element]="element">
                            </input-check>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="modal-header">
    <h4 class="modal-title pull-left">Voulez vous d'ajouter des options supplèmentaire ?</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-4">
            <div class="img">
                <img src="assets/images/chef.png" width="100%" alt="" srcset="">
            </div>
        </div>
        <div class="col-md-8">
            <div class="d-flex">
                <ng-container *ngFor="let element of options;let i=index">
                    <input-check class="mr-2" [theme]="'theme2'" [(ngModel)]="element.checked" name="add{{i}}"
                        [element]="element">
                    </input-check>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="next">
        <button class="btn btn-lg" (click)="valider()">
            Ajouter au panier
        </button>
    </div>
</div>